import request from "@/network/request"

// 微信公众号发票保存
export function saveInvoice(data) {
	return request({
		url: "/api/invoice/issue",
		method: 'post',
		data
	});
}